/** @jsxImportSource react */

import { ValidCalcTools } from '@react/tools/constants/data';
import dynamic from 'next/dynamic';

import { ToolDetails } from '../types';

const CareQuizTool = dynamic(
  () => import('@react/tools/components/CareQuizTool')
);
const MatchWithAdvisorTool = dynamic(
  () => import('@react/tools/components/MatchWithAdvisorTool')
);
const NearbyCitiesTool = dynamic(
  () => import('@react/tools/components/NearbyCitiesTool')
);
const NeighborhoodInsightsTool = dynamic(
  () => import('@react/tools/components/NeighborhoodInsightsTool')
);

const PricingCalculatorTool = dynamic(
  () => import('@react/tools/components/PricingCalculatorTool')
);

const PersonalizedSeniorlyLivingOptions = dynamic(
  () => import('@react/tools/components/PersonalizedSeniorlyLivingOptions')
);

export default function CalculatorAndQuizzes({
  toolName,
  toolProp,
  heading,
  description,
  shortDescription,
}: {
  toolName: ValidCalcTools;
} & ToolDetails) {
  switch (toolName) {
    case 'senior-living-cost-calculator':
      return (
        <PricingCalculatorTool
          heading={heading}
          description={description}
          shortDescription={shortDescription}
        />
      );
    case 'care-quiz':
      return (
        <CareQuizTool
          toolProp={toolProp}
          heading={heading}
          description={description}
          shortDescription={shortDescription}
        />
      );
    case 'match-with-advisor':
      return (
        <MatchWithAdvisorTool
          heading={heading}
          description={description}
          shortDescription={shortDescription}
        />
      );
    case 'compare-price-nearby':
      return (
        <NearbyCitiesTool
          heading={heading}
          description={description}
          shortDescription={shortDescription}
        />
      );
    case 'neighborhood-insights':
      return (
        <NeighborhoodInsightsTool
          heading={heading}
          description={description}
          shortDescription={shortDescription}
        />
      );
    case 'get-personalized-list-of-senior-living-options':
      return (
        <PersonalizedSeniorlyLivingOptions
          heading={heading}
          description={description}
          shortDescription={shortDescription}
        />
      );
    default:
      return null;
  }
}
